/* istanbul ignore file */
import * as jwtDecode from 'jwt-decode'

export { jwtDecode }

export function jwtGetClaim(jwt, claimName) {
  const decoded = jwtDecode(jwt)
  return decoded[
    Object.keys(jwtDecode(jwt)).filter(
      key => key.indexOf('claims/' + claimName) > 0
    )
  ]
}

export function getKeycloakClaim(jwt, claimName) {
  const decoded = jwtDecode(jwt)
  return decoded[claimName]
}
